<mat-form-field>
    <mat-select
        [value]="selected"
        (selectionChange)="handleChange($event.value)">
        <mat-option
            *ngFor="let option of options"
            [value]="option">{{ option }}</mat-option>
    </mat-select>
</mat-form-field>
<emm-search-by-location
    *ngIf="selected === 'Location'"
></emm-search-by-location>
<emm-location-sets-dropdown
    *ngIf="selected === 'Location Sets'"
    class="location-sets-dropdown"
></emm-location-sets-dropdown>
